import React, { FC, useState } from 'react';

import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import { RewardCategories } from 'components/app-header/loyalty/rewards-management/reward-tier-selection-modal/components/reward-categories';
import { HeaderLogo } from 'components/app-header/mobile-header/header-logo';
import Modal from 'components/modal';
import { StickyFooter } from 'components/sticky-footer';
import useDialogModal from 'hooks/use-dialog-modal';

import {
  AllModalContent,
  Background,
  ModalCloseButton,
  PositionedLogoContainer,
  RewardCategoriesContainer,
} from './reward-tier-selection-modal.styled';
import { IRewardCategoriesModalProps } from './types';

export const RewardTierSelectionModal: FC<IRewardCategoriesModalProps> = ({
  onDismiss,
  radioButtonName,
  onChangeRewardTier,
  selectedRewardTierId,
  selectedRewardCategoryId,
}) => {
  const { formatMessage } = useIntl();

  const [currentRewardTierId, setCurrentRewardTierId] = useState<string>(
    selectedRewardTierId ?? ''
  );
  const [currentRewardCategoryId, setCurrentRewardCategoryId] = useState(selectedRewardCategoryId);

  const updateRewardTier = () => {
    onChangeRewardTier(currentRewardTierId);
    onDismiss();
  };

  const [UpdateNotSavedModal, openUpdateNotSavedModal] = useDialogModal({
    onConfirm: () => updateRewardTier,
    onCancel: onDismiss,
    showCancel: true,
    modalAppearanceEventMessage: 'Remove Favorite',
    allowDismiss: false,
  });

  const updateCurrentRewardTier = ({
    updatedRewardCategoryId,
    updatedRewardTierId,
  }: {
    updatedRewardCategoryId?: string;
    updatedRewardTierId: string;
  }) => {
    setCurrentRewardTierId(updatedRewardTierId);
    setCurrentRewardCategoryId(updatedRewardCategoryId);
  };

  const ensureTierUpdated = () => {
    if (currentRewardTierId === selectedRewardTierId) {
      return onDismiss();
    }

    return openUpdateNotSavedModal();
  };

  return (
    <Modal
      closeButton={ModalCloseButton}
      onDismiss={ensureTierUpdated}
      mParticleEventData={{ modalAppearanceEventMessage: 'Reward Categories' }}
    >
      <AllModalContent>
        <Background>
          <PositionedLogoContainer>
            <HeaderLogo />
          </PositionedLogoContainer>
          <RewardCategoriesContainer>
            <RewardCategories
              radioButtonName={radioButtonName}
              setCurrentRewardTierId={updateCurrentRewardTier}
              selectedRewardCategoryId={currentRewardCategoryId}
              selectedRewardTierId={currentRewardTierId}
            />
          </RewardCategoriesContainer>
        </Background>
        <StickyFooter
          padding={'1.5rem 1rem calc(1rem + env(safe-area-inset-bottom)) 1rem'} //TODO: the onClick for the action button will receive the correct assignment on the next PR
          elements={[
            {
              element: (
                <ActionButton onClick={updateRewardTier} fullWidth>
                  {formatMessage({ id: 'updateRewardLevel' })}
                </ActionButton>
              ),
            },
          ]}
        />
      </AllModalContent>

      <UpdateNotSavedModal
        buttonLabel={formatMessage({ id: 'updateRewardLevel' })}
        heading={formatMessage({ id: 'yourUpdateIsntSavedYetHeading' })}
        body={formatMessage({ id: 'yourUpdateIsntSavedYetBody' })}
        cancelLabel={formatMessage({ id: 'discard' })}
      />
    </Modal>
  );
};
